<template>
    <div
        ref="floatingRef"
        class="z-[999]"
    >
        <div
            v-if="slots?.trigger != null"
            @mouseenter="setShowTooltip"
            @mouseleave="hideTooltip"
            class="flex"
        >
            <slot name="trigger"/>
        </div>

        <Teleport to="#tooltips-container">
            <div
                ref="floating"
                v-if="showFloating"
                :style="{
                    ...floatingStyles,
                    ...positionStyles,
                    visibility: middlewareData?.hide?.referenceHidden
                        ? 'hidden'
                        : 'visible'
                }"
                class="z-[9999]"
            >
                <slot name="floating-content"/>
            </div>
        </Teleport>
    </div>
</template>

<script setup>
import { ref, toRefs, Teleport, useSlots } from "vue";
import { storeToRefs } from "pinia";
import { useFloating, flip, offset, autoUpdate, hide } from "@floating-ui/vue";

import { useMousePosition } from "../../store/mouse-position.store";

import { PLACEMENT_OPTIONS } from "../../utils/floating-ui";

const props = defineProps({
    placement: {
        default: 'bottom',
        validator: (prop) => {
            return PLACEMENT_OPTIONS.includes(prop)
        }
    },
    show: {
        type: Boolean,
        default: false
    },
    showOnMousePosition: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const { placement, showOnMousePosition, disabled } = toRefs(props)

const slots = useSlots();

const floatingRef = ref(null)
const floating = ref(null);
const showFloating = ref(false);

const setShowTooltip = () => {
    if (disabled.value) return
    showFloating.value = true
}

const hideTooltip = () => {
    if (disabled.value) return
    showFloating.value = false
}

const mousePositionStore = useMousePosition();
const { posX, posY } = storeToRefs(mousePositionStore)

const { floatingStyles, middlewareData } = useFloating(floatingRef, floating, {
    placement: placement.value,
    middleware: [flip(), offset(4), hide()],
    whileElementsMounted: autoUpdate,
});

const positionStyles = showOnMousePosition.value ? {top: `${posX}px`, left: `${posY}px`} : {}
</script>
